import React, { useState } from "react";
import "../styles/FaqSection.css";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";

const faqs = [
  {
    question: "What is SuperManager and how does it work?",
    answer:
      "SuperManager is an IoT-based monitoring system that tracks machine performance, operation time, downtime, and worker efficiency using smart sensors and cloud analytics."
  },
  {
    question: "How does SuperManager help improve productivity?",
    answer:"SuperManager provides real-time insights, identifies inefficiencies, tracks output, detects downtime, and enables data-driven decision-making to optimize workflows and boost productivity."
  },
  {
    question: "Do I need any technical expertise to use SuperManager?",
    answer:
      "No. SuperManager is designed for easy adoption with simple dashboards, automated data collection, and one-click reports—no technical background required."
  },
  {
    question: "Can I access my dashboard remotely?",
    answer:
      "Yes. You can monitor your machines and reports from anywhere using your desktop, tablet, or mobile device."
  },
  {
    question: "Does SuperManager work with older machines?",
    answer:
      "Yes. Our sensors and hardware modules are designed to integrate with both modern and legacy industrial machines."
  }
];

export default function Faqs() {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="faq-section">
      <div className="faq-container">
        <button className="faq-tag">Frequently Asked Questions</button>
        <h2 className="faq-title">Everything You Need to <br></br>Know About Us</h2>
        <div className="faq-list">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className={`faq-item ${openIndex === index ? "open" : ""}`}
              onClick={() => toggleFAQ(index)}
            >
              <div className="faq-question">
                <h3>{faq.question}</h3>
                {openIndex === index ? (
                  <FaChevronUp className="icon" />
                ) : (
                  <FaChevronDown className="icon" />
                )}
              </div>
              <div className="faq-answer">
                <p>{faq.answer}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
